import { useHasRole } from '@app/core/auth/authorization/hooks/useHasRole';
import { Device, UserRole } from '@mi-front/core';
import { streamerBoxStreamerBoxDevicesList } from '@mi-front/api-v2';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

/**
 * React Query hook to fetch all streamer box devices via api-v2.
 * Only fetches if user is not a basic user (CLIENT_USER).
 */
export function useStreamerBoxDevices(): UseQueryResult<readonly Device[], Error> {
  const isBasicUser = useHasRole(UserRole.CLIENT_USER);

  return useQuery<readonly Device[]>({
    queryKey: useStreamerBoxDevices.queryKey(),
    queryFn: () => streamerBoxStreamerBoxDevicesList() as unknown as Promise<readonly Device[]>,
    enabled: !isBasicUser,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

/**
 * Query key factory for streamer box devices query.
 */
useStreamerBoxDevices.queryKey = () => ['streamerBox', 'devices'] as const;
